<template lang="pug">
	.product-selection-component
		.product-list
			.product(v-for="item in items", :class="{selected: selectedValues.indexOf(item.oid) > -1, 'justify-space-between': item.logo}", @click="toggleProduct(item)")
				slot(v-if="$scopedSlots.card", name="card" :data="item")
				template(v-else)
					template(v-if="item.icon")
						.icon
							i(:class="[item.icon]")
						.name {{item.name}}
						.description(v-if="item.description") {{item.description}}
					template(v-else)
						.spacer
						img.logo(:src="item.logo", v-if="item.logo")
						.bottom-info
							.name {{item.name}}
							.description(v-if="item.description") {{item.description}}
				.check
					i.fas.fa-check
</template>

<script>
	import VueTypes from 'vue-types';

	export default {
		translationCategory: 'proposal.ProductSelectionComponent',
		name: 'product-selection-component',
		props: {
			items: VueTypes.array.def([]),
			selectedValues: VueTypes.array.def([])
		},
		data() {
			return {
				screen(width) {
					return (width < 900) ? 'xs' : 'lg';
				}
			};
		},
		mounted() {
			if (__DEBUG__)
				console.log('Product selection mounted', this);
		},
		methods: {
			toggleProduct(product) {
				if (product.click) {
					return product.click();
				}

				this.$emit('select', product);

				if (this.selectedValues) {
					const prodIdx = this.selectedValues.indexOf(product.oid);
					if (prodIdx > -1) {
						this.selectedValues.splice(prodIdx, 1);
						this.$emit('remove', product.oid);
					} else {
						this.selectedValues.push(product.oid);
						this.$emit('add', product.oid);
					}
				}
			}
		}
	};
</script>
<style lang='scss'>
	.product-selection-component {
		@import "main/themes/generated/variables.base.scss";

		.justify-space-between{
			justify-content: space-between !important;
		}
		.product-list {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: center;

			> .product {
				min-width: 200px;
				min-height: 200px;
				background: #fff;
				border-radius: 8px;
				padding: 20px;
				margin: 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				-webkit-box-shadow: 2px 2px 13px 2px rgba(0,0,0,0.1);
				-moz-box-shadow: 2px 2px 13px 2px rgba(0,0,0,0.1);
				box-shadow: 2px 2px 13px 2px rgba(0,0,0,0.1);
				transition: 0.3s;
				position: relative;

				> .icon {
					font-size: 60px;
					color: $base-accent;
				}

				> .logo {
					max-width: 180px;
					max-height: 180px;
				}

				> .name {
					font-size: 18px;
					font-weight: 100;
				}

				> .description {
					font-size: 14px;
					font-weight: 100;
				}

				> .check {
					position: absolute;
					right: 0px;
					top: 10px;
					width: 64px;
					height: 64px;
					color: rgba(255, 255, 255, 0);
					font-size: 20px;
					text-align: center;
				}

				&:hover, &.selected {
					cursor: pointer;
					background: $base-accent;
					color: #fff;
					transform: scale(1.05);

					> .icon {
						color: #fff;
						font-size: 72px;
						transition: 0.3s;
					}
				}

				&.selected {
					background: $base-accent;
					transform: scale(1);

					> .check {
						transition: 0.3s;
						transform: scale(1);
						color: rgba(255, 255, 255, 1);
						font-size: 30px;
					}
				}

				> .bottom-info {
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;
					width: 100%;
					justify-content: space-between;
				}
			}
		}
	}
</style>
